import { createSelector } from 'reselect';
import Resdit7421PerformanceDetailsColumns from '../../containers/Resdit7421PerformanceDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.RESDIT_74_21_PERFORMANCE_DETAILS_107B.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RESDIT_74_21_PERFORMANCE_DETAILS_107B.isLoading;

export const getData =
  ReportDefinitions.RESDIT_74_21_PERFORMANCE_DETAILS_107B.getDataFunction();

export const getColumns =
  createSelector(getData, Resdit7421PerformanceDetailsColumns);
